export const NAVIGATION_RECOLLECT_DELAY_MS = 600;
type EpochState = { url: string; epoch: number; layer: unknown[] | undefined; startIndex: number; initialized: boolean; recollection?: Promise<void> };

let state: EpochState = { url: '', epoch: 0, layer: undefined, startIndex: 0, initialized: false };

function layerNow(): unknown[] | undefined {
  return typeof window !== 'undefined' && Array.isArray(window.dataLayer) ? window.dataLayer : undefined;
}

export function currentNavigationEpoch(url: string): { epoch: number; startIndex: number; layer: unknown[] | undefined } {
  const layer = layerNow();
  if (!state.initialized) {
    state = { url, epoch: 0, layer, startIndex: 0, initialized: true };
  } else if (state.url !== url) {
    state = { url, epoch: state.epoch + 1, layer, startIndex: layer?.length ?? 0, initialized: true,
      recollection: new Promise(resolve => setTimeout(resolve, NAVIGATION_RECOLLECT_DELAY_MS)) };
  } else if (state.layer !== layer || (layer?.length ?? 0) < state.startIndex) {
    state = { ...state, layer, startIndex: 0 };
  }
  return { epoch: state.epoch, startIndex: state.startIndex, layer };
}

export function beginNavigationEpoch(url: string): void {
  currentNavigationEpoch(url);
}

export function waitForNavigationRecollection(url: string): Promise<void> {
  currentNavigationEpoch(url);
  return state.recollection ?? Promise.resolve();
}

export function resetNavigationEpochForTests(): void {
  state = { url: '', epoch: 0, layer: undefined, startIndex: 0, initialized: false };
}
